// Header.tsx
import React, { useContext } from 'react';
import './Header.scss';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './../AuthContext';

interface HeaderProps {
  hideMenu?: boolean;
}

const Header: React.FC<HeaderProps> = ({ hideMenu = false }) => {
  const { isAuthenticated, signOut } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  const handleFeedback = async () => {
    navigate('/feedback');
  };

  const handleSignIn = async () => {
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <div className="link-wrapper" onClick={() => navigate('/')}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 60" width="200" height="60">
              <defs>
                <style>
                  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap');
                </style>
              </defs>
              <text x="10" y="45" fontFamily="Poppins, sans-serif" fontSize="40" fontWeight="600" fill="#333333">
                Kitchen<tspan fill="#4CAF50">9</tspan>
              </text>
              <rect x="10" y="50" width="154" height="4" fill="#4CAF50" />
            </svg>
          </div>
        </div>
        {!hideMenu && (
          <>
            <nav className="nav-links">
              <div className="nav-item" onClick={() => navigate('/generate')}>
                Generate
              </div>
              <div className="nav-item" onClick={() => navigate('/recipes')}>
                Recipes
              </div>
              <div className="nav-item" onClick={() => navigate('/grocery')}>
                Groceries
              </div>
              {/*
              <div className="nav-item" onClick={() => navigate('/localflavors')}>
                Local Kitchens
              </div>  */}
            </nav>
            <div className="auth-buttons">
              <button className="feedback-button" onClick={handleFeedback}>
                Share Feedback
              </button>
              {isAuthenticated ? (
                <button className="auth-button" onClick={handleSignOut}>
                  Sign Out
                </button>
              ) : (
                <button className="auth-button" onClick={handleSignIn}>
                  Log In
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;